import { useState, useRef } from 'react';
import { IconSearch, IconCircleXFilled } from '@tabler/icons-react';
import { Input } from '@components/amc/Input';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SearchInput = ({
  placeholder = '',
  width = null,
  disabled = false,
  defaultValue = null,
  autoFocus = false,
  onEnterKeyDown = null
}) => {
  const [value, setValue] = useState(defaultValue || '');
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);
  const handleClear = () => {
    setValue('');
    if (inputRef.current) {
      inputRef.current.value = '';
      inputRef.current.focus();
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "relative",
    style: {
      width: width || '100%'
    },
    children: [/*#__PURE__*/_jsx(Input, {
      ref: inputRef,
      value: value,
      type: "search",
      placeholder: placeholder,
      onChange: e => {
        setValue(e.target.value);
      },
      onFocus: () => setIsFocused(true),
      onBlur: () => setIsFocused(false),
      onKeyDown: e => {
        if (e.key === 'Enter') {
          onEnterKeyDown && onEnterKeyDown(value);
          e.preventDefault();
        }
      },
      disabled: disabled,
      autoFocus: autoFocus,
      iconLeft: /*#__PURE__*/_jsx(IconSearch, {
        size: 16,
        className: "text-foreground"
      }),
      className: "[&_input]:[-webkit-appearance:none] [&_input::-webkit-search-decoration]:hidden [&_input::-webkit-search-cancel-button]:hidden [&_input::-webkit-search-results-button]:hidden [&_input::-webkit-search-results-decoration]:hidden"
    }), value && isFocused && /*#__PURE__*/_jsx("button", {
      onClick: handleClear,
      onMouseDown: e => {
        e.preventDefault();
      },
      className: "absolute right-2.5 top-1/2 -translate-y-1/2 cursor-pointer z-10",
      children: /*#__PURE__*/_jsx(IconCircleXFilled, {
        size: 20,
        className: "text-muted-foreground"
      })
    })]
  });
};
export default SearchInput;